import polyglotI18nProvider from 'ra-i18n-polyglot';
import type { TranslationMessages } from 'ra-core';
import en from './en';
import es from './es';
import type { PayMessages } from './payMessages';

const catalogs: Record<string, TranslationMessages & { pay: PayMessages }> = { en, es };

/**
 * es-ES formal register is the active default locale (design-system §8 /
 * engineering standards). English is provided alongside every string so a
 * future locale switch is a configuration change, not a rewrite.
 */
export const i18nProvider = polyglotI18nProvider(
  (locale) => catalogs[locale] ?? es,
  'es',
  [
    { locale: 'es', name: 'Español' },
    { locale: 'en', name: 'English' },
  ],
);
